import React from 'react'
import classNames from 'classnames'

/* eslint-disable no-unused-vars */
export enum AnimatedLoadingVariant {
  Thinking = 'thinking',
  Action = 'action',
}
/* eslint-enable no-unused-vars */

interface AnimatedLoadingTextProps {
  text: string
  className?: string
  showDots?: boolean
  variant?: AnimatedLoadingVariant
}

const AnimatedLoadingText: React.FC<AnimatedLoadingTextProps> = ({
  text,
  className,
  showDots = true,
  variant = AnimatedLoadingVariant.Thinking,
}) => {
  const containerClassNames = classNames(
    {
      'pilot-animated-loading': true,
      'pilot-animated-loading--thinking': variant === AnimatedLoadingVariant.Thinking,
      'pilot-animated-loading--action': variant === AnimatedLoadingVariant.Action,
    },
    className
  )

  const renderAnimatedDots = () => (
    <span className='pilot-animated-loading__dots'>
      <span className='pilot-animated-loading__dot'>.</span>
      <span className='pilot-animated-loading__dot'>.</span>
      <span className='pilot-animated-loading__dot'>.</span>
    </span>
  )

  return (
    <div className={containerClassNames}>
      <span className='pilot-animated-loading__text'>
        {text}
        {showDots && renderAnimatedDots()}
      </span>
    </div>
  )
}

export default AnimatedLoadingText
